import { FC } from "react";

import { PIC } from "@ryde/assets";
import { MarkerIconType } from "@ryde/shared";
import { rydeColors } from "@ryde/theme";

import { MapLibreStationPinShape } from "./maplibre-station-pin-shape";
import {
  MapLibreStationPinAva,
  MapLibreStationPinBadge,
  MapLibreStationPinFinish,
  MapLibreStationPinRoot,
} from "./maplibre-station-pin.styled";

interface IMapLibreStationPinSvgProps {
  color: string;
  /**
   * The numbered disc on a drop-off pin, when it is not the pin's own colour. The passenger form's first
   * destination is a black flag pin with a purple badge; every other caller has the two agree.
   */
  badgeColor?: string;
  label?: string;
  type: MarkerIconType;
  /** Optional pin outline — used for routing waypoints (white ring). */
  stroke?: string;
}

/**
 * Tip-anchored SVG pin for MapLibre (`anchor="center"` on a 0×0 root).
 * DropOff matches Leaflet: white pin + clipped FinishSVG fill + badge.
 */
export const MapLibreStationPinSvg: FC<IMapLibreStationPinSvgProps> = ({
  color,
  badgeColor,
  label,
  type,
  stroke,
}) => {
  const isDropOff = type === MarkerIconType.DropOff;
  const isNumberedPin = type === MarkerIconType.Point;

  return (
    <MapLibreStationPinRoot>
      <div className="maplibre-station-pin-body">
        <MapLibreStationPinShape
          fill={isDropOff ? rydeColors.white : color}
          stroke={isDropOff ? color : stroke}
          label={isNumberedPin ? label : undefined}
        />

        {isDropOff ? (
          <MapLibreStationPinFinish $color={color}>
            <PIC.FinishSVG />
          </MapLibreStationPinFinish>
        ) : null}

        {type === MarkerIconType.Home ? (
          <MapLibreStationPinAva $color={rydeColors.white}>
            <PIC.HomeSVG />
          </MapLibreStationPinAva>
        ) : null}

        {type === MarkerIconType.Flag ? (
          <MapLibreStationPinAva $color={rydeColors.white}>
            <PIC.FlagSVG />
          </MapLibreStationPinAva>
        ) : null}

        {isDropOff && label ? (
          <MapLibreStationPinBadge $backgroundColor={badgeColor ?? color}>
            {label}
          </MapLibreStationPinBadge>
        ) : null}
      </div>
    </MapLibreStationPinRoot>
  );
};
